export default function getSlug(slug: string) {
  const parsedSlug = slug.split('-')
  if (parsedSlug.length > 0) {
    return parsedSlug[parsedSlug.length - 1]
  } else {
    return slug
  }
}
